document.addEventListener('DOMContentLoaded', () => {
    const addShowMoreButtonListeners = () => {
        const sections = document.querySelectorAll('.section-reviews-one');

        if (sections) {
            sections.forEach((section, index) => {
                const button = section.querySelector('.reviews-show-more');
                if (button) {
                    button.setAttribute('data-index', index + 1);
                }
            })
            sections.forEach((section) => {
                const button = section.querySelector(".reviews-show-more");
                if (button) {
                    button.addEventListener('click', async (event) => {
                        const button = event.target;
                        button.classList.add('btn-loading');

                        const sectionId = section?.id;

                        if (!section || !sectionId) {
                            console.error('Не удалось найти родительский блок секции.');
                            return;
                        }

                        const postId = button.getAttribute('data-post-id');
                        const number = parseInt(button.getAttribute('data-number'));
                        const offset = parseInt(button.getAttribute('data-offset'));
                        const cardSize = button.getAttribute('data-card-size');
                        const count = button.getAttribute('data-count');
                        const index = button.getAttribute('data-index');

                        const options = {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded',
                                'Cache-Control': 'no-cache',
                            },
                            mode: 'no-cors',
                        };

                        const form = new FormData();
                        form.append('action', 'load_more_reviews_one');
                        form.append('post_id', postId);
                        form.append('number', number);
                        form.append('offset', offset);
                        form.append('index', index)
                        form.append('card_size', cardSize);

                        const params = new URLSearchParams(form);
                        options.body = params;

                        try {
                            let response = await fetch('/wp-admin/admin-ajax.php', options);
                            let html = await response.text();
                            if (html) {
                                const reviewsList = section.querySelector('.section-reviews-one__block');
                                const lang = offset + number;
                                const total = parseInt(count, 10);
                                reviewsList.innerHTML = html;
                                if (lang >= total) {
                                    button.remove();
                                } else {
                                    button.setAttribute('data-offset', lang);
                                    button.classList.remove('btn-loading');
                                }
                            }
                        } catch (error) {
                            console.error('Ошибка при загрузке отзывов:', error);
                        }
                    });
                }
            });
        }
    };

    addShowMoreButtonListeners();
});